
import { Vue, Prop } from "vue-property-decorator";
export default class Tirscript3LoadingComponent extends Vue {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: false }) error!: boolean;
  @Prop({ default: false }) ok!: boolean;
  @Prop({ default: "Ошибка" }) errorMessage: string;
  @Prop({ default: "Операция прошла успешно" }) okMessage: string;
  @Prop({ default: "LOADING" }) loadingMessage: string;
  @Prop({ default: 1, type:Number}) loaderType: number;

  mounted() {
    (this.$el as any).parentElement.style.position = "relative";
  }
}
